import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/rapid-old",
  "description": "Обзор автомобиля ŠKODA RAPID (2015). Фото, описание, характеристики. Весь модельный ряд шкоды на официальном сайте ŠKODA в России",
  "huggerTemplate": "default",
  "keywords": "cедан,россия,лифтбек,шкод рапид в москве",
  "name": "rapid-old",
  "title": "SKODA RAPID (2015) - Обзор поколения модели и технические характеристики на официальном сайте ŠKODA в России"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageSubHeading = makeShortcode("SimpleMainStageSubHeading");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const SimpleMainStageButtonsWrapper = makeShortcode("SimpleMainStageButtonsWrapper");
const SimpleMainStageButton = makeShortcode("SimpleMainStageButton");
const SimpleTeaser = makeShortcode("SimpleTeaser");
const SimpleTeaserParagraph = makeShortcode("SimpleTeaserParagraph");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefSectionBtnContainer = makeShortcode("DefSectionBtnContainer");
const Button = makeShortcode("Button");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const QueriedShowRoomPromoSlider = makeShortcode("QueriedShowRoomPromoSlider");
const ModelList = makeShortcode("ModelList");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const QueriedGallery = makeShortcode("QueriedGallery");
const SimpleTeaserTitle = makeShortcode("SimpleTeaserTitle");
const ListMobileSlider = makeShortcode("ListMobileSlider");
const SlideIcon = makeShortcode("SlideIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="bottom" horizontalAlign="left" src="/m/rapid-old-main.jpg" mobileSrc="/m/rapid-old-main-mobile.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageSubHeading align="left" mdxType="SimpleMainStageSubHeading">
    Архивная модель
  </SimpleMainStageSubHeading>
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">ŠKODA RAPID</SimpleMainStageHeading>
  <SimpleMainStageButtonsWrapper mdxType="SimpleMainStageButtonsWrapper">
    <SimpleMainStageButton href="/models/rapid" mdxType="SimpleMainStageButton">
      Обновленный Rapid
    </SimpleMainStageButton>
  </SimpleMainStageButtonsWrapper>
    </SimpleMainStage>
    <SimpleTeaser aspect="2/1" src="/m/rapid-old-teaser1.jpg" bgColor="white" reversed mdxType="SimpleTeaser">
  <SimpleTeaserParagraph mdxType="SimpleTeaserParagraph">
    Послушный каждому движению водителя, автомобиль ŠKODA RAPID 2015 лифтбек
    отличается малым тормозным путем и хорошей управляемостью даже в крутых
    поворотах или при экстренном маневрировании. Обтекаемый корпус с отличной
    аэродинамикой, платформа с независимой подвеской, электромеханический
    усилитель руля — этот автомобиль создан для скорости и комфорта, будь то
    движение в плотном потоке машин или загородная поездка по свободной трассе.
  </SimpleTeaserParagraph>
    </SimpleTeaser>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button type="primary" href="/models/rapid-old#info" mdxType="Button">
      Подробная информация о ŠKODA RAPID 2015
    </Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Автомобили ŠKODA в наличии</DefaultSectionHeading>
  <QueriedShowRoomPromoSlider tags="archival yeti" mdxType="QueriedShowRoomPromoSlider" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Актуальный модельный ряд ŠKODA</DefaultSectionHeading>
  <ModelList modelsInfo={[{
        modelLine: "Rapid",
        previewSimple: "/m/rapid-menu-new.png",
        name: "Rapid",
        overviewLink: "/models/rapid"
      }, {
        modelLine: "Rapid",
        previewSimple: "/m/menu-new-rapid-he-1.png",
        name: "RAPID HOCKEY EDITION",
        overviewLink: "/models/rapid-hockey-edition"
      }, {
        modelLine: "Rapid",
        previewSimple: "/m/rapid-menu-sport.png",
        name: "RAPID SPORT EDITION",
        overviewLink: "/models/rapid-sport-edition"
      }, {
        modelLine: "Octavia",
        previewSimple: "/m/grey1-2020.png",
        name: "OCTAVIA",
        overviewLink: "/models/octavia"
      }, {
        modelLine: "Octavia",
        previewSimple: "/m/octavia-he-blue2.png",
        name: "OCTAVIA HOCKEY EDITION",
        overviewLink: "/models/octavia-hockey-edition"
      }, {
        modelLine: "Kodiaq",
        previewSimple: "/m/kodiaq-2021-menu-newspoiler.png",
        name: "KODIAQ",
        overviewLink: "/models/kodiaq"
      }, {
        modelLine: "Kodiaq",
        previewSimple: "/m/kodiaqfl-2022-menu_sportline.png",
        name: "KODIAQ SPORTLINE",
        overviewLink: "/models/kodiaq-sportline"
      }, {
        modelLine: "Kodiaq",
        previewSimple: "/m/kodiaqfl-2022-menu-lk.png",
        name: "KODIAQ LAURIN KLEMENT",
        overviewLink: "/models/kodiaq-laurin-klement"
      }, {
        modelLine: "Superb",
        previewSimple: "/m/superb_new_active.png",
        name: "SUPERB",
        overviewLink: "/models/superb"
      }, {
        modelLine: "Superb",
        previewSimple: "/m/superb_combi_new_style.png",
        name: "SUPERB COMBI",
        overviewLink: "/models/superb-combi"
      }, {
        modelLine: "Karoq",
        previewSimple: "/m/karoq_style.png",
        name: "KAROQ",
        overviewLink: "/models/karoq"
      }, {
        modelLine: "Karoq",
        previewSimple: "/m/karoq-he.png",
        name: "KAROQ HOCKEY EDITION",
        overviewLink: "/models/karoq-hockey-edition"
      }]} mdxType="ModelList" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    Дополнения в базовых комплектациях!
  </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Базовые комплектации ŠKODA RAPID получились еще богаче! Для всех
    комплектаций доступна розетка в багажнике на случай, если вы, например,
    захотите подключить к автомобилю колонки и устроить праздник на природе. Мы
    также улучшили звучание и добавили в комплектации Ambition и Style функцию
    ŠKODA Surround, чтобы даже на задних сиденьях пассажиры наслаждались
    полноценным звучанием каждого произведения. Также в эти комплектации
    добавлены функцией Bluetooth и противотуманными фарами с функцией освещения
    поворотов.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <SimpleTeaser aspect="2/1" src="/m/rapid-old-teaser2.jpg" bgColor="white" reversed mdxType="SimpleTeaser">
  <SimpleTeaserParagraph mdxType="SimpleTeaserParagraph">
    Еще больше функциональных Simply Clever решений вместе со ŠKODA: у
    комплектации Style появился зонтик на случай дождя и специальное место под
    сиденьем пассажира для него! Уникальное сочетание привлекательного дизайна и
    современных технологий отражено в конструкции рулевого колеса, отделанного
    приятной натуральной кожей. Также в него встроена система управления радио и
    телефоном, которая поможет вам не отвлекаться на дороге. Дисплей Maxi Dot
    является незаменимым помощником в долгих поездках! Он отображает не только
    информацию бортового компьютера, но и данные о работе других систем
    автомобиля, таких как кондиционер и навигационная система.
  </SimpleTeaserParagraph>
    </SimpleTeaser>
    <SimpleTeaser aspect="2/1" src="/m/rapid-old-teaser3.jpg" bgColor="white" mdxType="SimpleTeaser">
  <SimpleTeaserParagraph mdxType="SimpleTeaserParagraph">
    В ŠKODA RAPID добвлен обогрев лобового стекла, чтобы сократить время
    подготовки автомобиля к поездке в зимнее время. Благодаря этому получается
    чистое стекло с отличным обзором даже в самое холодное время года! ŠKODA
    RAPID оборудован камерой заднего вида, которая помогает водителю лучше
    контролировать ситуацию при парковке или движении задним ходом. А благодаря
    омывателю камеры изображение всегда четкое. Расширена цветовая линейка ŠKODA
    RAPID и добавлен желтый цвет автомобиля для тех, кто хочет, чтобы их
    автомобиль был ярче и выделялся на дороге.
  </SimpleTeaserParagraph>
    </SimpleTeaser>
    <DefaultPaddedSection mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Седан в стиле ŠKODA</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    В модели RAPID реализована концепция дизайна марки ŠKODA, олицетворяющая
    современность и динамичность облика. Объединенные решетка радиатора и фары
    формируют единый дизайнерский элемент, визуально расширяющий автомобиль.
    Профиль ŠKODA RAPID​ привлекает внимание изящными выверенными линиями и
    четкими гранями, в которых легко угадывается просторный интерьер. Форма
    задних дверей обеспечивает комфортную посадку и обещает огромное
    пространство для задних пассажиров. Темперамент автомобиля ощущаются даже
    при взгляде на него сзади. Резко очерченные треугольные элементы по бокам
    площадки для номерного знака являются еще одной эффектной деталью.
  </DefaultSectionText>
  <FeaturesSliderQueried tags="rapid-old-design" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <div id="info"></div>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Интерьер</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Для достижения максимального впечатления от управления RAPID предлагалась
    одна из нескольких цветовых комбинаций для передней панели. В зависимости от
    комплектации, передняя панель могла быть выполнена в цветах черный-серый или
    черный-черный, и дополняться трехспицевым рулевым колесом. Все сиденья ŠKODA
    RAPID гарантируют комфортную посадку. Передние сиденья с развитой боковой
    поддержкой обеспечивают надежную фиксацию водителя и переднего пассажира на
    поворотах. Крайние сиденья заднего ряда также имеют ярко выраженную
    анатомическую форму для наивысшего комфорта двух пассажиров, однако при
    необходимости на заднем ряду смогут с удобством расположиться три пассажира.
  </DefaultSectionText>
    </DefaultPaddedSection>
    <QueriedGallery presetName="3" tags="rapid-old-interior" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Вместительность</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Полезное пространство салона и объем багажного отделения — ключевые
    особенности ŠKODA RAPID. Благодаря широкому салону и просторному заднему
    ряду автомобиль легко вмещает пять человек и обеспечивает комфортное
    путешествие четырем взрослым людям. Стандартный объем багажного отделения в
    530 литров способен увеличиваться до внушительных 1470 литров простым
    складыванием задних сидений.​
  </DefaultSectionText>
  <FeaturesSliderQueried tags="rapid-old-room" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <SimpleTeaser aspect="2/1" src="/m/rapid-old-teaser-body.jpg" bgColor="white" mdxType="SimpleTeaser">
  <SimpleTeaserTitle mdxType="SimpleTeaserTitle">Багажное отделение</SimpleTeaserTitle>
  <SimpleTeaserParagraph mdxType="SimpleTeaserParagraph">
    Объем багажного отделения составляет 530 литров и может быть увеличен до
    1470 литров путем складывания спинок задних сидений. Крышка багажного
    отделения оснащена удобной ручкой, которая находится изнутри с правой
    стороны. Для дополнительного удобства повседневного использования
    предлагался специальный пакет оснащения багажного отделения, в который
    входили вещевые отсеки позади колесных арок и комплект сеток для крепления
    различных предметов. Кроме того, багажное отделение оснащено полкой,
    элементами крепления багажа и подсветкой.
  </SimpleTeaserParagraph>
    </SimpleTeaser>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Комфорт </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    ŠKODA RAPID оснащается множеством электронных систем, повышающих комфорт и
    безопасность пассажиров, а так же функциональность автомобиля.
  </DefaultSectionText>
  <QueriedShowRoomPromoSlider tags="rapid-old-comfort" mdxType="QueriedShowRoomPromoSlider" />
    </DefaultPaddedSection>
    <DefaultPaddedSection mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    Подушки безопасности и защита от столкновений
  </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Подушки безопасности предназначены для предотвращения контакта любой части
    тела водителя или пассажира с жесткими компонентами автомобиля. В
    комплектации данной модели ŠKODA предусмотрено до девяти подушек
    безопасности.
  </DefaultSectionText>
  <FeaturesSliderQueried tags="rapid-old-airbag" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <SimpleTeaser aspect="2/1" src="/m/rapid-old-esc-teaser.jpg" bgColor="#FFF" mdxType="SimpleTeaser">
  <SimpleTeaserTitle mdxType="SimpleTeaserTitle">
    Система поддержания курсовой устойчивости (ESC)
  </SimpleTeaserTitle>
  <SimpleTeaserParagraph mdxType="SimpleTeaserParagraph">
    ESC, или система поддержания курсовой устойчивости, помогает водителю
    справляться с критическими ситуациями, когда автомобиль начинает уходить в
    занос. Блок управления непрерывно сравнивает текущие данные о поведении
    автомобиля на дороге с предустановленными значениями. Если значения не
    совпадают, блок управления дает системе команду стабилизировать движение
    автомобиля. Программа поддержания курсовой устойчивости использует
    возможности систем ABS, ASR и сигналы ряда других специальных датчиков. Это
    позволяет предотвратить скольжение или блокировку колес. Принцип работы ESC
    заключается в ограничении крутящего момента двигателя и подтормаживании
    внутреннего заднего колеса в случае недостаточной поворачиваемости или
    внешнего переднего колеса в случае избыточной поворачиваемости.​
  </SimpleTeaserParagraph>
    </SimpleTeaser>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Жесткая конструкция кузова</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p>
      Высококачественная жесткая конструкция кузова является основой
      безопасности при любых видах аварий. Для достижения высокой прочности
      несущего кузова были использованы исключительно прочные материалы,
      особенно в пассажирском пространстве, где допустимы только минимальные
      деформации.
    </p>
    <p>
      Передняя и задняя части автомобиля обеспечивают максимальное поглощение
      энергии во время аварии. Специальные опоры предотвращают попадание
      двигателя в салон — в случае сильного удара он смещается под днище
      автомобиля, не причиняя вреда пассажирам.
    </p>
    <p>
      Конструкция рулевой колонки ограничивает движение рулевого колеса в случае
      фронтального удара. Конструкция педалей обеспечивает соскальзывание в
      случае удара, уменьшая риск травмы ноги водителя.
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Другие средства безопасности</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    ŠKODA RAPID заботится о безопасности всех пассажиров. За свои образцовые
    меры безопасности этот вместительный семейный автомобиль получил «5 звезд»
    по результатам краш-тестов Euro NCAP в 2012 году. В дополнение к основным
    системам безопасности, для ŠKODA RAPID предусмотрены в качестве стандартного
    или дополнительного оборудования следующие функции:
  </DefaultSectionText>
  <ListMobileSlider mdxType="ListMobileSlider">
    <SlideIcon icon="/m/icon-check.svg" title="ABS" size="small" text="Предотвращает блокировку колес при экстренном торможении или при торможении на скользком дорожном покрытии." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="Тормозной ассистент" size="small" text="Помогает водителю в ситуациях, требующих интенсивного торможения. Это приводит к значительному сокращению тормозного пути." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="MSR" size="small" text="предотвращает блокировку ведущих колес на скользкой дороге, если водитель резко отпускает педаль акселератора." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="ASR" size="small" text="обеспечивает плавное трогание с места и разгон без пробуксовки колес на скользких дорожных покрытиях." contentMaxWidth="300px" mdxType="SlideIcon" />
    <SlideIcon icon="/m/icon-check.svg" title="Ассистент трогания на подъеме" size="small" text="Помогает безопасно начать движение на крутом уклоне. Система включается автоматически на уклоне крутизной от 5 % и обеспечивает легкое и безопасное начало движения без использования ручного тормоза. Она предотвращает скатывание автомобиля назад или выключение двигателя." contentMaxWidth="300px" mdxType="SlideIcon" />
  </ListMobileSlider>
    </DefaultPaddedSection>
    <SimpleTeaser aspect="2/1" src="/m/old-to-rapid-new.png" bgColor="#FAFAFA" reversed mdxType="SimpleTeaser">
  <SimpleTeaserParagraph mdxType="SimpleTeaserParagraph">
    В этом разделе представлена информация о лифтбеке ŠKODA RAPID, 2015
    модельный год. Если вас интересует актуальная модель – обратите внимание на
    ŠKODA RAPID:
  </SimpleTeaserParagraph>
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button type="primary" href="/models/rapid/" mdxType="Button">
      Узнать больше о ŠKODA RAPID
    </Button>
  </DefSectionBtnContainer>
    </SimpleTeaser>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      